import { render, staticRenderFns } from "./errorDialog.vue?vue&type=template&id=36fd3715&scoped=true"
import script from "./errorDialog.vue?vue&type=script&lang=js"
export * from "./errorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fd3715",
  null
  
)

export default component.exports